import { Grid2 as Grid, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Typography, Paper, Fade } from "@mui/material";
import * as React from "react";
import { Theme, createStyles } from '@mui/material/styles';
import { withStyles, WithStyles } from '@mui/styles';;
import { connect } from "react-redux";
import idssStyle from "../../Configuration/SharedStyling";
import { IGenericUserProps, genericMapStateToProps } from '../../DataClasses/GenericUser';
import { FindInPage as FindInPageIcon } from '@mui/icons-material';
import AdministrationService from "../Services/AdministrationService";
import { firstValueFrom } from 'rxjs';
import LoadingDataTable from "../Shared/LoadingDataTable";



const styles = (theme: Theme) => createStyles({
    ...idssStyle(theme),
    root: {
        flexGrow: 1
    },
    list: {
        flexGrow: 1
    },
    menuContainer: {
        textAlign: "right",
        paddingRight: "10px"
    }
});
type IStylesProps = WithStyles<typeof styles>;

interface ILocalState {
    IsDownloading: boolean;
    anchorEl: HTMLElement | null;
    docs: { key: string; title: string; description?: string; href: string }[];
    isLoading: boolean;
}


// VIEW
class HelpView extends React.Component<IGenericUserProps & IStylesProps, ILocalState> {


    constructor(props: any) {
        super(props);

        this.state = {
            IsDownloading: false,
            anchorEl: null,
            docs: [],
            isLoading: true
        };
    }

    public async componentDidMount() {
        await this.loadDocs();
    }

    private async loadDocs() {
        try {
            const docs = await firstValueFrom(AdministrationService.GetHelpDocs$());
            this.setState({ docs, isLoading: false });
        }
        catch {
            this.setState({ docs: [], isLoading: false });
        }
    }

    public render() {
        const { classes } = this.props;
        return (
            <Grid container className={classes.root} spacing={2}
                direction="row"
                justifyContent="flex-start"
                alignItems="flex-start"
                alignContent="flex-start"
            >
                <Grid size={10} className={classes.mt2 + " " + classes.mb2}>
                    <Typography className={classes.submissionTitle}>
                        Help
                    </Typography>
                </Grid>
                {this.state.isLoading ?
                    <Grid size={11}>
                        <LoadingDataTable count={8} titleText={""} doubleRowSpace={true} width="70%" />
                    </Grid>
                    :
                    <>
                        <Fade in={true}>
                            <Grid size={11}>
                                <Paper>
                                    <List className={classes.list} >
                                        {this.state.docs.map(doc => (
                                            doc?.href ? this.renderLink(doc.href, doc.title, doc.description, doc.key) : null
                                        ))}
                                    </List>
                                </Paper>
                            </Grid>
                        </Fade>
                    </>
                }
            </Grid>
        );
    }

    private readonly renderLink = (href: string, primaryText: string, secondaryText?: string, key?: string) => {
        return (
            <ListItem key={key || href} alignItems='flex-start' divider>
                <ListItemButton onClick={() => this.downloadHelpDoc(href, primaryText, key)}>
                    <ListItemIcon>
                        <FindInPageIcon />
                    </ListItemIcon>
                    <ListItemText primary={primaryText} secondary={secondaryText} />
                </ListItemButton>
            </ListItem>
        );
    }

    private readonly isPresigned = (href?: string) => {
        return !!href && (href.includes('X-Amz-') || href.includes('.s3.') || href.includes('X-AmzSignature'));
    }

    private readonly handlePresignedDownload = (href: string, keyName?: string, title?: string) => {
        const extFromKey = keyName ? (keyName.substring(keyName.lastIndexOf('.')) || '') : '';
        const isPdf = extFromKey.toLowerCase() === '.pdf' || href.toLowerCase().includes('.pdf');
        if (isPdf) {
            window.open(href, '_blank');
            window.opener = null;
        } else {
            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            iframe.src = href;
            document.body.appendChild(iframe);
            setTimeout(() => {
                try {
                    iframe.remove();
                } catch (err) {
                    console.debug('getExtensionFromHrefOrKey: invalid URL', href, err);
                }
            }, 60000);
        }
    }

    private readonly getExtensionFromHrefOrKey = (href: string, keyName?: string) => {
        let extension = '';
        try {
            const url = new URL(href);
            const path = url.pathname;
            const idx = path.lastIndexOf('.');
            if (idx !== -1 && path.length - idx <= 10) {
                extension = path.substring(idx);
            }
        } catch (err) {
            console.error('context message', err);
        }

        if (!extension && keyName) {
            try {
                const idx = keyName.lastIndexOf('.');
                if (idx !== -1 && keyName.length - idx <= 10) {
                    extension = keyName.substring(idx);
                }
            } catch (err) {
                console.error('context message', err);
            }
        }
        return extension;
    }

    private readonly mapContentTypeToExtension = (contentType: string) => {
        const map: Record<string, string> = {
            'application/pdf': '.pdf',
            'application/msword': '.doc',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx',
            'text/plain': '.txt',
            'text/csv': '.csv',
            'application/zip': '.zip',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': '.xlsx',
            'application/vnd.ms-excel': '.xls',
            'application/xml': '.xml'
        };
        return map[contentType] || '';
    }

    private readonly createBlobWithType = (blobResp: Blob, contentType: string | undefined, extension: string) => {
        if (blobResp?.type) {
            return blobResp;
        }
        let inferredType: string | undefined;
        if (contentType) {
            inferredType = contentType;
        } else if (extension) {
            inferredType = extension.replace(/^\./, '').toLowerCase() === 'csv' ? 'text/csv' : '';
        } else {
            inferredType = undefined;
        }
        return new Blob([blobResp], { type: inferredType });
    }

    private readonly openOrDownload = (blobUrl: string, contentType: string | undefined, blobType: string, extension: string, filename: string) => {
        if (contentType === 'application/pdf' || blobType === 'application/pdf' || (extension && extension.toLowerCase() === '.pdf')) {
            window.open(blobUrl, '_blank');
            window.opener = null;
            setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
        } else {
            const a = document.createElement('a');
            a.href = blobUrl;
            a.download = filename;
            a.rel = 'noopener noreferrer';
            document.body.appendChild(a);
            a.click();
            a.remove();
            setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
        }
    }

    private readonly downloadHelpDoc = async (href: string, title: string, keyName?: string) => {
        if (!href) {
            console.warn('downloadHelpDoc called without href');
            return;
        }

        this.setState({ IsDownloading: true });
        try {
            if (this.isPresigned(href)) {
                this.handlePresignedDownload(href, keyName, title);
                return;
            }

            const resp = await fetch(href);
            if (!resp.ok) {
                window.open(href, '_blank');
                window.opener = null;
                return;
            }

            const contentTypeRaw = (resp.headers.get('Content-Type') || '');
            const contentType = contentTypeRaw.split(';')[0].trim().toLowerCase();

            let extension = this.getExtensionFromHrefOrKey(href, keyName);
            if (!extension) {
                extension = this.mapContentTypeToExtension(contentType);
            }

            const safeTitle = (title || 'download').replaceAll(/\s+/g, '_').replaceAll(/[^\w\-\.]/g, '');
            const filename = safeTitle + extension;

            const blobResp = await resp.blob();
            const blob = this.createBlobWithType(blobResp, contentType, extension);
            const blobUrl = URL.createObjectURL(blob);

            this.openOrDownload(blobUrl, contentType, blob.type, extension, filename);
        }
        catch (err) {
            console.error('downloadHelpDoc failed', err);
            window.open(href, '_blank');
            window.opener = null;
        }
        finally {
            this.setState({ IsDownloading: false });
        }
    }
}

// REDUX CONTAINER
const HelpPageWithState = connect<IGenericUserProps>(genericMapStateToProps)(HelpView);

// STYLES CONTAINER
const HelpViewPage = withStyles(styles)(HelpPageWithState);

export default HelpViewPage;